import { z } from '@/libs/zod';

import { LuckySequencyType, PrizeType } from '../enums';

export const cartRaffleSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  ticketsAmount: z.number(),
  totalPrice: z.number(),
  winning: z.boolean(),
  cartId: z.string(),
  cartStatus: z.string(),
});

export const prizeSchema = z.object({
  name: z.string(),
  prizeValue: z.number(),
  type: PrizeType,
});

export const userSchema = z.object({
  name: z.string(),
  cpf: z.string(),
  phone: z.string(),
});

export const raffleDetailSchema = z.object({
  id: z.string(),
  name: z.string(),
  numbering: z.number(),
  status: z.string(),
  drawDate: z.string(),
  urlThumbnail: z.string(),
  urlWhatsapp: z.string().nullable(),
  urlFacebook: z.string().nullable(),
  redirectRaffleUrl: z.string().nullable(),
  maxTicketsPerCpf: z.number(),
  urlScratcherBanner: z.string(),
  model: z.object({
    luckySequencyType: LuckySequencyType,
    free: z.boolean(),
  }),
  prizes: z.array(prizeSchema),
  cartRaffle: z.array(cartRaffleSchema),
  availablePrizes: z.array(prizeSchema),
  ticketsBought: z.number(),
  lastPurchase: z.string(),
  user: userSchema,
});

export type CartRaffle = z.infer<typeof cartRaffleSchema>;
export type Prize = z.infer<typeof prizeSchema>;
export type User = z.infer<typeof userSchema>;
export type RaffleDetail = z.infer<typeof raffleDetailSchema>;

export type RaffleDetailParams = {
  raffleId: string;
  cpf: string;
  phone: string;
};
